module.exports = __webpack_public_path__ + "static/media/24.01e78de3.svg";